<adsk-forge-viewer [viewerOptions]="viewerOptions3d">
</adsk-forge-viewer>